// extracted by mini-css-extract-plugin
export default {"container":"p6PUU8WD7OMc0LIvzsDk"};